
export { LucideIcon } from "/codebuild/output/src1412605272/src/packages/shared-components/src/components/LucideIcon.tsx"